import { InitiativeCountry } from 'basics/enums/country.enums';

const countryKeys = Object.keys(InitiativeCountry);
const countryValues = Object.values(InitiativeCountry);
const initiativeCountryOptions = countryValues.map((value, index) => { return { id: countryKeys[index], label: value }; });

export default initiativeCountryOptions;
